export const guestUserIBANSelect = (state) => state.user?.guestDetails?.iban;
export const userTypeSelect = (state) => state.user?.userType;
